export default {
    name: 'AppHeader',    
    created() {
        this.CheckLoginStatus();
    },
    data() {
        return {  
            loginDetails: null,
            Info: [],
            TempInfo: [],
            Count: 0,
        };
    },
  
    methods: {

        href(url) {
            this.$router.push(url);
        },

        Logout() {
            window.location.href = "/Login";
        },

        CheckLoginStatus() {
            try {
                this.loginDetails = JSON.parse(localStorage.getItem('currentUser-client'));
                if (this.loginDetails == null) {
                    window.location.href = '/Login';
                }
            } catch (error) {
                window.location.href = '/Login';
            }
        },

        playSound() {
            const audio = new Audio("windows8_email_notif.mp3");
            audio.play();
        }
    }    
}
